import './index.css';
import useTheme from '../../utilities/hooks/theme';
import { Modal } from '@mui/material';
import View from '../view';
import constants from '../../constants';
import { convertToDollars } from '../../utilities/helper';

const MiniGamesConfirmationModal = ({
  visible = false,
  onPressDismiss,
  onConfirmationHandler,
  EntryFee = 0
}: any) => {
  const { FantasyTheme: theme } = useTheme();
  return (
    <Modal open={visible} onClose={onPressDismiss}>
      <View
        className={'minigames_confirmation_modal_wrapper'}
        style={{
          backgroundColor: theme.contestFilterContainer
        }}>
        <div className={'minigames_confirmation_modal_container'}>
          <div className="minigames_confirmation_modal_money_wrapper">
            <img src={constants.Images.coin} />
          </div>
          <div className="minigames_confirmation_modal_entry_prize">{`${convertToDollars(
            EntryFee
          )}`}</div>
          <div className="minigames_confirmation_modal_confirmation_txt">
            Pay Entry Fee to continue?
          </div>
          <div className="minigames_confirmation_modal_footer_wrapper">
            <button className="minigames_confirmation_modal_no_btn" onClick={onPressDismiss}>
              No
            </button>
            <button
              className="minigames_confirmation_modal_yes_btn"
              onClick={onConfirmationHandler}>
              Yes
            </button>
          </div>
        </div>
      </View>
    </Modal>
  );
};

export default MiniGamesConfirmationModal;
